import { combineReducers } from 'redux';
import { ADD_MULTIPLE_LABELS } from '../actions/actiontypes';

function addOrUpdateLabels(state, labels) {
  // return the state with the multiple labels added/replaced
  const newState = { ...state };
  labels.forEach((label) => {
    const { name, definition, point_types, equipment_types } = label;
    newState[label.name] = {
      name,
      definition,
      point_types,
      equipment_types,
    };
  });
  return newState;
}

function labelsByName(state = {}, action) {
  switch (action.type) {
    case ADD_MULTIPLE_LABELS:
      return addOrUpdateLabels(state, action.labels);
    default:
      return state;
  }
}

const labelReducer = combineReducers({
  byName: labelsByName,
});

export default labelReducer;
